<template>
  <div class="manage-users">
    <b-table-simple
      hover small caption-top responsive>
      <b-thead head-variant="light">
        <b-tr>
          <b-th>Full Name</b-th>
          <b-th>Display Name</b-th>
          <b-th>Email</b-th>
          <b-th>Phone</b-th>
          <b-th>Last Login</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr
          v-for="user in users"
          :key="user.id">
          <b-td class="font-weight-bold">
            {{ user.firstName }} {{ user.lastName }}
          </b-td>
          <b-td>
            {{ user.displayName }}
          </b-td>
          <b-td>
            <a
              :href="`mailto:${user.email}`">
              {{ user.email }}
            </a>
          </b-td>
          <b-td>
            <a
              v-if="user.phone"
              :href="`tel:${user.phone}`">
              {{ user.phone }}
            </a>
            <span v-else>
              None
            </span>
          </b-td>
          <b-td>
            <span v-if="user.loggedInAt">
              {{ user.loggedInAt | relativeDate }}
            </span>
            <span v-else>
              Never
            </span>
          </b-td>
        </b-tr>
      </b-tbody>
      <b-tfoot>
        <b-tr>
          <b-td
            colspan="7"
            class="text-right">
            Total Rows: <b>{{ users.length }}</b>
          </b-td>
        </b-tr>
      </b-tfoot>
    </b-table-simple>
  </div>
</template>

<script>
import relativeDate from '@/filters/relativeDate.filter'

export default {
  name: 'ManageUsers',
  filters: {
    relativeDate,
  },
  data() {
    return {
      users: [],
    }
  },
  methods: {
    async getUsers() {
      const usersResponse = await this.$http.get('/users')
      this.users = usersResponse.data.users
    },
  },
  created() {
    this.getUsers()
  },
}
</script>
